import { TranslationKeys } from '@/localization';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type SelectHintProps = {
  hint: TranslationKeys;
  className?: string;
};

const SelectHintComp: FC<SelectHintProps> = ({ hint, className }) => {
  const { t } = useTranslation();

  return <p className={twMerge('text-tertiary-600 first-letter:capitalize', className)}>{t(hint as any)}</p>;
};

export const SelectHint = memo(SelectHintComp);
